import styled from 'styled-components';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';
import promoZIndex from 'theme/promoZIndex';
import zIndex from 'theme/zIndex';

export const HeaderDesktopContainer = styled.header`
    background: ${promoColors.white};
    border-bottom: 1px solid ${promoColors.gray5};
`;

export const HeaderDesktopContent = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;
    padding-left: 24px;
    padding-right: 24px;

    ${promoMedia.tablet744} {
        max-width: 640px;
        padding-left: 64px;
        padding-right: 64px;
    }

    ${promoMedia.desktop1440} {
        max-width: 1280px;
        padding-left: 160px;
        padding-right: 160px;
    }
`;

export const FlexPanel = styled.div`
    align-items: center;
    display: flex;
    height: 71px;
    justify-content: space-between;

    ${promoMedia.desktop1440} {
        height: 87px;
    }
`;

export const HeaderDesktopLibre = styled.div`
    position: relative;
    z-index: ${promoZIndex.headerDesktopLibre};

    ${FlexPanel} {
        height: 72px;

        ${promoMedia.desktop1440} {
            height: 88px;
        }
    }
`;

export const HeaderLogo = styled.div`
    width: 116px;

    svg {
        max-width: 100%;

        path {
            fill: ${promoColors.white};
        }
    }
`;

export const TabNameDesktop = styled.a`
    background-color: ${(props) => (props.isSelected ? promoColors.purple5 : promoColors.white)};
    align-items: center;
    border-radius: 48px;
    cursor: pointer;
    display: flex;
    padding: 12px 24px;
    white-space: nowrap;

    &:hover {
        background-color: ${promoColors.purple5};
    }

    &:focus-visible {
        outline: 1px dashed ${promoColors.purple20};

        & + nav {
            display: block;
        }
    }
`;

export const TopMenuLink = styled.a`
    align-items: center;
    cursor: pointer;
    background-color: ${(props) => (props.isSelected ? promoColors.purple5 : null)};
    display: flex;
    padding: 20px 24px;

    &:hover {
        background-color: ${promoColors.purple5};
    }

    &:focus-visible {
        outline: 1px dashed ${promoColors.gray40};
    }
`;

export const TopMenu = styled.ul`
    display: none;
    font-size: 16px;
    line-height: 24px;
    color: ${promoColors.gray80};
    list-style-type: none;
    margin: 0;
    padding: 0;

    ${promoMedia.desktop1440} {
        display: flex;
    }

    & > li {
        nav {
            display: none;
        }

        &:hover > ${TabNameDesktop} {
            background-color: ${promoColors.purple5};

            & + nav {
                display: block;
            }
        }
    }

    ${promoMedia.desktop1440} {
        nav {
            left: 0;
            position: absolute;
            top: 104px;
            z-index: ${zIndex.navTopMenu};

            &::before {
                bottom: -12px;
                content: '';
                left: -12px;
                opacity: 0;
                pointer-events: all;
                position: absolute;
                right: -12px;
                top: -40px;
                z-index: ${zIndex.navTopMenuOverlay};
            }

            & > ul {
                background-color: ${promoColors.white};
                border-radius: 16px;
                box-shadow: ${promoColors.shadowCollected};
                overflow: hidden;
                padding: 12px 0;
                width: 288px;
            }
        }

        & > li {
            cursor: pointer;
            max-width: none;
            padding: 20px 0 19px;
            position: relative;
        }
    }
`;

export const ToggleNavModal = styled.span`
    margin-right: -8px;

    ${promoMedia.desktop1440} {
        display: none;
    }
`;

export const TopMenuIcon = styled.img`
    border: none;
    margin-right: 16px;
    min-width: 24px;
    vertical-align: top;
`;
export const AuthMenu = styled.ul`
    display: flex;
    justify-content: ${(props) => (props.hasOneButton ? 'end' : 'center')};
    list-style-type: none;
    margin: 0;
    padding: 0;

    & > li {
        white-space: nowrap;
    }
`;
export const AuthWrapper = styled.div`
    display: none;

    ${AuthMenu} {
        & > li {
            & + li {
                margin-left: 16px;
            }
        }
    }

    ${promoMedia.desktop1440} {
        display: block;
    }
`;

export const CorrespondNav = styled.nav`
    margin-left: auto;
    margin-right: auto;
    max-width: 480px;
    position: relative;

    ${promoMedia.tablet744} {
        max-width: 688px;
        padding-left: 40px;
        padding-right: 40px;
    }
`;
export const OverlayNavigation = styled.div`
    background-color: ${promoColors.white};
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 104px;
    padding-top: 24px;
    position: fixed;
    right: 0;
    top: 72px;
    z-index: 7;

    ${AuthMenu} {
        height: 0;
        margin-left: auto;
        margin-right: auto;
        max-width: 432px;

        a {
            box-shadow: 8px 8px 16px 2px rgba(228, 214, 255, 0.6);
        }

        & > li {
            height: 56px;
            min-width: calc(50% - 12px);
            text-align: center;

            & + li {
                margin-left: 24px;
            }
        }
    }

    ${promoMedia.tablet744} {
        padding-bottom: 200px;

        ${AuthMenu} {
            max-width: none;

            & > li {
                height: 72px;
                width: auto;
                min-width: auto;
            }
        }
    }

    ${promoMedia.desktop1440} {
        display: none;
    }
`;

export const NavigationWrapper = styled.div`
    width: 100vw;
`;

export const TabNameMobile = styled.a`
    padding: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    background: ${(props) => (props.isSelected ? promoColors.purple5 : null)};

    &:focus-visible {
        background-color: ${promoColors.gray5};
        outline: 1px dashed ${promoColors.gray40};
    }
`;
export const TabIcon = styled.span`
    display: inline-flex;
    transform: ${(props) => (props.isOpenedTab ? 'rotate(180deg)' : null)};
    transition: transform 0.4s ease-in-out;
`;
export const MenuLink = styled.a`
    display: block;
    padding: 22px 24px;
    background: ${(props) => (props.isSelected ? promoColors.purple5 : null)};

    &:hover {
        background: ${promoColors.purple5};
    }

    &:focus-visible {
        outline: 1px dashed ${promoColors.gray20};
    }
`;

export const FixedPanel = styled.div`
    bottom: 80px;
    height: auto;
    left: 0;
    padding-left: 24px;
    padding-right: 24px;
    position: fixed;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;

    ${promoMedia.tablet744} {
        bottom: 96px;
        max-width: 640px;
        padding-left: 64px;
        padding-right: 64px;
    }
`;
